(function () {
  'use strict';

  var script = document.currentScript;
  var mapUrl = script && script.getAttribute('data-review-map');
  var selector = '[data-lux-review-skus]';
  var mapPromise = null;

  if (!mapUrl) return;

  function loadMap() {
    if (mapPromise) return mapPromise;

    mapPromise = new Promise(function (resolve) {
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 8000);

      fetch(mapUrl, {
        cache: 'force-cache',
        credentials: 'same-origin',
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Review map unavailable');
          return response.json();
        })
        .then(function (data) { resolve(data && typeof data === 'object' ? data : {}); })
        .catch(function () { resolve({}); })
        .finally(function () { window.clearTimeout(timeout); });
    });

    return mapPromise;
  }

  function summaryFor(card, reviewMap) {
    var seen = {};
    var total = 0;
    var weighted = 0;
    var skus = (card.getAttribute('data-lux-review-skus') || '').split('|');

    skus.forEach(function (rawSku) {
      var sku = rawSku.trim().toUpperCase();
      if (!sku || seen[sku]) return;
      seen[sku] = true;
      var entry = reviewMap[sku];
      if (!Array.isArray(entry)) return;
      var rating = Number(entry[0]);
      var count = Number(entry[1]);
      if (!Number.isFinite(rating) || !Number.isFinite(count) || rating <= 0 || count <= 0) return;
      weighted += rating * count;
      total += count;
    });

    return total ? { rating: weighted / total, count: total } : null;
  }

  function render(card, reviewMap) {
    if (!card || card.getAttribute('data-lux-review-ready') === 'true') return;
    var badge = card.querySelector('[data-lux-review-summary]');
    if (!badge) return;

    var summary = summaryFor(card, reviewMap);
    card.setAttribute('data-lux-review-ready', 'true');
    if (!summary) return;

    var ratingText = summary.rating.toFixed(1);
    var value = badge.querySelector('[data-lux-review-value]');
    var count = badge.querySelector('[data-lux-review-count]');
    if (value) value.textContent = ratingText;
    if (count) count.textContent = '(' + summary.count + ')';
    badge.setAttribute(
      'aria-label',
      ratingText + ' out of 5 from ' + summary.count + ' verified pre-owned ' + (summary.count === 1 ? 'purchase' : 'purchases')
    );
    badge.hidden = false;
  }

  function cardsWithin(root) {
    var cards = [];
    if (root && root.nodeType === 1 && root.matches(selector)) cards.push(root);
    if (root && root.querySelectorAll) {
      cards = cards.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }
    return cards;
  }

  function hydrate(root) {
    var cards = cardsWithin(root || document);
    if (!cards.length) return;
    loadMap().then(function (reviewMap) {
      cards.forEach(function (card) { render(card, reviewMap); });
    });
  }

  function start() {
    hydrate(document);
    document.addEventListener('shopify:section:load', function (event) { hydrate(event.target); });

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType === 1) hydrate(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

// Shopify can briefly serve a stale cached homepage after a theme publish.
// Replace only the known placeholder drop with the current rendered section.
(function () {
  'use strict';

  var currentSectionId = 'template--27534569898018__luxury_featured_drop';

  function hasStaleFeaturedDrop() {
    var titles = document.querySelectorAll('.lux-featured-drop .grid-product__title');
    if (!titles.length) return false;
    return Array.prototype.every.call(titles, function (title) {
      return title.textContent.trim() === 'Curated luxury piece';
    });
  }

  function refreshFeaturedDrop() {
    if (!hasStaleFeaturedDrop()) return;
    var oldSection = document.querySelector('[id^="shopify-section-"][id*="luxury_featured_drop"]');
    if (!oldSection) return;

    fetch('/?sections=' + encodeURIComponent(currentSectionId) + '&llb_featured_refresh=' + Date.now(), {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Featured drop refresh failed');
        return response.json();
      })
      .then(function (sections) {
        var html = sections && sections[currentSectionId];
        if (!html) return;
        var template = document.createElement('template');
        template.innerHTML = html.trim();
        var nextSection = template.content.firstElementChild;
        if (!nextSection) return;
        oldSection.replaceWith(nextSection);
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: currentSectionId } }));
      })
      .catch(function () {
        // The existing section remains usable while Shopify finishes refreshing its page cache.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFeaturedDrop, { once: true });
  } else {
    refreshFeaturedDrop();
  }
})();
